/**
 * proteinPage_Display__SingleProtein_MainContent_Component_nonClass_Functions.ts
 * 
 * Functions for proteinPage_Display__SingleProtein_MainContent_Component.tsx
 * 
 */


// import { reportWebErrorToServer } from 'page_js/reportWebErrorToServer';

//   Modification Mass Rounding to provide some level of commonality between searches
import {modificationMass_CommonRounding_ReturnNumber,} from 'page_js/data_pages/modification_mass_common/modification_mass_rounding';
//   Reporter Ion Mass Rounding to provide some level of commonality between searches
import {reporterIonMass_CommonRounding_ReturnNumber,} from 'page_js/data_pages/reporter_ion_mass_common/reporter_ion_mass_rounding';

import {
    proteinSequenceWidgetDisplay_Component_Data__Build,
    ProteinSequenceWidgetDisplay_Component_Data__Build__staticModificationMassesForProteinPositions_PARAM,
    ProteinSequenceWidgetDisplay_Component_Data__Build__staticModificationMassesForProteinPositions_PARAM_Entry,
} from 'page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__protein_page__components/protein_sequence_display_widget/js/proteinSequenceWidgetDisplay_Component_Data__Build';
import {ProteinSequenceWidgetDisplay_Component_Data} from 'page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__protein_page__components/protein_sequence_display_widget/js/proteinSequenceWidgetDisplay_Component_Data';
import {ProteinSequenceWidget_StateObject} from 'page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__protein_page__components/protein_sequence_display_widget/js/proteinSequenceWidget_StateObject';

import {PeptideSequence_UserSelections_StateObject} from 'page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__core__components__peptide__single_protein/peptide_sequence_selected/js/peptideSequence_UserSelections_StateObject';
import {PeptideSequence_UserSelections_ComponentData} from 'page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__core__components__peptide__single_protein/peptide_sequence_selected/js/peptideSequence_UserSelections_ComponentData';
import {peptideSequence_UserSelections_BuildData_ForReactComponent} from 'page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__core__components__peptide__single_protein/peptide_sequence_selected/js/peptideSequence_UserSelection_BuildData_ForReactComponent';
import {UserSearchString_LocationsOn_ProteinSequence_Root} from 'page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__core__components__peptide__single_protein/userSearchString_LocationsOn_ProteinSequence/userSearchString_LocationsOn_ProteinSequence_ComponentData';
import {userSearchString_LocationsOn_ProteinSequence_Compute} from 'page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__core__components__peptide__single_protein/userSearchString_LocationsOn_ProteinSequence/userSearchString_LocationsOn_ProteinSequence_Compute';

import {modificationMass_UserSelections_BuildData_ForReactComponent} from 'page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__core__components__peptide__single_protein/filter_on__modification__reporter_ion/modification_mass_user_selections/js/modificationMass_UserSelections_BuildData_ForReactComponent';
import {ModificationMass_UserSelections_StateObject} from 'page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__core__components__peptide__single_protein/filter_on__modification__reporter_ion/modification_mass_user_selections/js/modificationMass_UserSelections_StateObject';
import {ModificationMass_UserSelections_ComponentData} from 'page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__core__components__peptide__single_protein/filter_on__modification__reporter_ion/modification_mass_user_selections/js/modificationMass_UserSelections_ComponentData';

import {
    reporterIonMass_UserSelections_BuildData_ForReactComponent,
    ReporterIonMass_UserSelections_ComponentData
} from 'page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__core__components__peptide__single_protein/filter_on__modification__reporter_ion/reporter_ions_user_selections/js/reporterIonMass_UserSelections_BuildData_ForReactComponent';
import {ReporterIonMass_UserSelections_StateObject} from 'page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__core__components__peptide__single_protein/filter_on__modification__reporter_ion/reporter_ions_user_selections/js/reporterIonMass_UserSelections_StateObject';

import {
    GetReportedPeptideIdsForDisplay_AllProjectSearchIds_Class,
    Peptide__single_protein_getReportedPeptideIds_From_SelectionCriteria_AllProjectSearchIds
} from 'page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/reported_peptide_ids_for_display/peptide__single_protein_getReportedPeptideIds_From_SelectionCriteria_AllProjectSearchIds'

import {getSequenceCoverageBooleanArray_ForReportedPeptideIds} from 'page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__single_protein/protein_sequence_display_widget__ForProtExp_SingleProtein/proteinSequenceWidgetDisplay_GetSequenceCoverage_FilteredOnReportedPeptideIds';
import {getSequenceCoverageBooleanArray_NotFiltered} from 'page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__single_protein/protein_sequence_display_widget__ForProtExp_SingleProtein/proteinSequenceWidgetDisplay_GetSequenceCoverage_NotFiltered';
import {PeptideUnique_UserSelection_ComponentData} from "page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__core__components__peptide__single_protein/peptide_unique_user_filter_selection/js/peptideUnique_UserSelection_ComponentData";
import {peptideUnique_UserSelection_BuildData_ForReactComponent} from "page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__core__components__peptide__single_protein/peptide_unique_user_filter_selection/js/peptideUnique_UserSelection_BuildData_ForReactComponent";
import {PeptideUnique_UserSelection_StateObject} from "page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__core__components__peptide__single_protein/peptide_unique_user_filter_selection/js/peptideUnique_UserSelection_StateObject";
import {SearchSubGroup_In_SearchDetailsAndFilter_Component_DisplayData} from "page_js/data_pages/search_sub_group/search_sub_group_in_search_details_outer_block/jsx/searchSubGroup_In_SearchDetailsOuterBlock";
import {searchSubGroup_Get_Selected_SearchSubGroupIds} from "page_js/data_pages/search_sub_group/js/searchSubGroup_Get_Selected_SearchSubGroupIds";
import {searchSubGroup_Create__SearchSubGroup_In_SearchDetailsAndFilter_Component_DisplayData} from "page_js/data_pages/search_sub_group/search_sub_group_in_search_details_outer_block/js/searchSubGroup_Create__SearchSubGroup_In_SearchDetailsAndFilter_Component_DisplayData";
import {SearchDetailsAndFilterBlock_MainPage_Root_Props_PropValue} from "page_js/data_pages/search_details_block__project_search_id_based/jsx/searchDetailsAndFilterBlock_MainPage_Root";
import {searchSubGroup_Are_All_SearchSubGroupIds_Selected__Fcn} from "page_js/data_pages/search_sub_group/js/searchSubGroup_Are_All_SearchSubGroupIds_Selected";
import {ModificationMass_OpenModMassZeroNotOpenMod_UserSelection_ComponentData} from "page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__core__components__peptide__single_protein/filter_on__modification__reporter_ion/modification_mass_open_mod_mass_zero_not_open_mod_user_selection/js/modificationMass_OpenModMassZeroNotOpenMod_UserSelection_ComponentData";
import {ModificationMass_OpenModMassZeroNotOpenMod_UserSelection__CentralStateManagerObjectClass} from "page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__core__components__peptide__single_protein/filter_on__modification__reporter_ion/modification_mass_open_mod_mass_zero_not_open_mod_user_selection/js/modificationMass_OpenModMassZeroNotOpenMod_UserSelection__CentralStateManagerObjectClass";
import {modificationMass_OpenModMassZeroNotOpenMod_UserSelection_Build_ComponentData_ForReactComponent} from "page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__core__components__peptide__single_protein/filter_on__modification__reporter_ion/modification_mass_open_mod_mass_zero_not_open_mod_user_selection/js/modificationMass_OpenModMassZeroNotOpenMod_UserSelection_Build_ComponentData";
import {ProteinPage_Display__SingleProtein_MainContent_Component_Props_Prop} from "page_js/data_pages/project_search_ids_driven_pages/protein_page/protein_page__single_protein/jsx/proteinPage_Display__SingleProtein_MainContent_Component";
import {ScanFilenameId_On_PSM_Filter_UserSelection_StateObject} from "page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__core__components__peptide__single_protein/scan_file_name_on_psms_selection/js/scanFilenameId_On_PSM_Filter_UserSelection_StateObject";
import {Scan_RetentionTime_MZ_UserSelections_StateObject} from "page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__core__components__peptide__single_protein/scan_retention_time_precursor_m_z_selection/js/scan_RetentionTime_MZ_UserSelections_StateObject";
import {CommonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root} from "page_js/data_pages/common_data_loaded_from_server__per_search_plus_some_assoc_common_data__with_loading_code__except_mod_main_page/commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root";
import {CommonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Single_ProjectSearchId} from "page_js/data_pages/common_data_loaded_from_server__per_search_plus_some_assoc_common_data__with_loading_code__except_mod_main_page/commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__SingleProjectSearch";
import {CommonData_LoadedFromServer_SingleSearch__Variable_Dynamic_Modifications_At_ProteinSequenceVersionId_Level_For_MainFilters_Holder} from "page_js/data_pages/common_data_loaded_from_server__per_search_plus_some_assoc_common_data__with_loading_code__except_mod_main_page/common_data_loaded_from_server_single_search_sub_parts__returned_objects/commonData_LoadedFromServer_SingleSearch__Variable_Dynamic_Modifications_At_ProteinSequenceVersionId_Level_For_MainFilters";
import {reportWebErrorToServer} from "page_js/common_all_pages/reportWebErrorToServer";
import {limelight__Sort_ArrayOfNumbers_SortArrayInPlace} from "page_js/common_all_pages/limelight__Sort_ArrayOfNumbers_SortArrayInPlace";
import {Psm_Charge_Filter_UserSelection_StateObject} from "page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__core__components__peptide__single_protein/psm_charge/psm_Charge_Filter_UserSelection_StateObject";
import {PeptideSequence_MissedCleavageCount_UserSelections_StateObject} from "page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__core__components__peptide__single_protein/filter_on__peptide_sequence_missed_cleavage_count/js/peptideSequence_MissedCleavageCount_UserSelections_StateObject";
import {
    PeptideMeetsDigestion_AKA_TrypticPeptide_Etc_UserSelections_StateObject,
    PeptideMeetsDigestion_AKA_TrypticPeptide_Etc_UserSelections_StateObject__SelectionEnum
} from "page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__core__components__peptide__single_protein/filter_on__peptide_meets_digestion__aka_tryptic_peptide_etc/peptideMeetsDigestion_AKA_TrypticPeptide_Etc_UserSelections_StateObject";
import { PeptideList_PeptidePage_SingleProtein_FilterOnCounts_psm_UserSelections_StateObject } from "page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__core__components__peptide__single_protein/filter_on_counts_psm/js/peptideList_PeptidePage_SingleProtein_FilterOnCounts_psm_UserSelections_StateObject";
import {
    ScanNumber_ScanFilenameId_ProjectSearchId_On_PSM_Filter_UserSelection_StateObject
} from "page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__core__components__peptide__single_protein/scan_number_and_file_name_or_search__on_psms_selection/js/scanNumber_ScanFilenameId_ProjectSearchId_On_PSM_Filter_UserSelection_StateObject";
import {
    ScanPeak_M_Over_Z__Intensity_Filter_UserSelection_StateObject
} from "page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__core__components__peptide__single_protein/scan_peak__mz_intensity/js/scanPeak_M_Over_Z__Intensity_Filter_UserSelection_StateObject";


/**
 * return type of linksToExternalResources
 */  
class ProteinPage_Display__SingleProtein_MainContent_Component_nonClass_Functions__LinksToExternalResources_Class {
    NCBI_Blast_URL : string
    PDR_Blast_URL : string
    UniProtKB_Search_URL : string
    NCBI_Search_URL : string
}

/**
 * 'async'
 */  
const initialPopulate = async function(
    {
        propsValue,
        proteinSequenceVersionId,
        proteinSequenceString,
        projectSearchIds,
        modificationMass_UserSelections_StateObject,
        modificationMass_OpenModMassZeroNotOpenMod_UserSelection__CentralStateManagerObjectClass,
        reporterIonMass_UserSelections_StateObject,
        scanFilenameId_On_PSM_Filter_UserSelection_StateObject,
        scanNumber_ScanFilenameId_ProjectSearchId_On_PSM_Filter_UserSelection_StateObject,
        scanPeak_M_Over_Z__Intensity_Filter_UserSelection_StateObject,
        scan_RetentionTime_MZ_UserSelection_StateObject,
        psm_Charge_Filter_UserSelection_StateObject,
        peptideUnique_UserSelection_StateObject,
        peptideSequence_UserSelections_StateObject,
        peptideSequence_MissedCleavageCount_UserSelections_StateObject,
        peptideMeetsDigestion_AKA_TrypticPeptide_Etc_UserSelections_StateObject,
        peptideList_PeptidePage_SingleProtein_FilterOnCounts_psm_UserSelections_StateObject,
        proteinSequenceWidget_StateObject,
        commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root,
        getReportedPeptideIdsForDisplay_AllProjectSearchIds_Object
    } : {
        propsValue : ProteinPage_Display__SingleProtein_MainContent_Component_Props_Prop
        proteinSequenceVersionId : number,
        proteinSequenceString : string,
        projectSearchIds : Array<number>,
        modificationMass_UserSelections_StateObject : ModificationMass_UserSelections_StateObject,
        modificationMass_OpenModMassZeroNotOpenMod_UserSelection__CentralStateManagerObjectClass : ModificationMass_OpenModMassZeroNotOpenMod_UserSelection__CentralStateManagerObjectClass
        reporterIonMass_UserSelections_StateObject : ReporterIonMass_UserSelections_StateObject,
        scanFilenameId_On_PSM_Filter_UserSelection_StateObject : ScanFilenameId_On_PSM_Filter_UserSelection_StateObject
        scanNumber_ScanFilenameId_ProjectSearchId_On_PSM_Filter_UserSelection_StateObject : ScanNumber_ScanFilenameId_ProjectSearchId_On_PSM_Filter_UserSelection_StateObject
        scanPeak_M_Over_Z__Intensity_Filter_UserSelection_StateObject : ScanPeak_M_Over_Z__Intensity_Filter_UserSelection_StateObject
        scan_RetentionTime_MZ_UserSelection_StateObject : Scan_RetentionTime_MZ_UserSelections_StateObject
        psm_Charge_Filter_UserSelection_StateObject: Psm_Charge_Filter_UserSelection_StateObject
        peptideUnique_UserSelection_StateObject : PeptideUnique_UserSelection_StateObject;
        peptideSequence_UserSelections_StateObject : PeptideSequence_UserSelections_StateObject,
        peptideSequence_MissedCleavageCount_UserSelections_StateObject: PeptideSequence_MissedCleavageCount_UserSelections_StateObject
        peptideMeetsDigestion_AKA_TrypticPeptide_Etc_UserSelections_StateObject: PeptideMeetsDigestion_AKA_TrypticPeptide_Etc_UserSelections_StateObject
        peptideList_PeptidePage_SingleProtein_FilterOnCounts_psm_UserSelections_StateObject : PeptideList_PeptidePage_SingleProtein_FilterOnCounts_psm_UserSelections_StateObject
        proteinSequenceWidget_StateObject : ProteinSequenceWidget_StateObject
        commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root: CommonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root
        getReportedPeptideIdsForDisplay_AllProjectSearchIds_Object: GetReportedPeptideIdsForDisplay_AllProjectSearchIds_Class
    }  ) :

Promise<{
    searchDetailsAndFilterBlock_MainPage_Root_Props_PropValue : SearchDetailsAndFilterBlock_MainPage_Root_Props_PropValue
    searchSubGroup_Ids_Selected : Set<number>
    searchSubGroup_Are_All_SearchSubGroupIds_Selected : boolean
    searchSubGroup_PropValue : SearchSubGroup_In_SearchDetailsAndFilter_Component_DisplayData
    linksToExternalResources : ProteinPage_Display__SingleProtein_MainContent_Component_nonClass_Functions__LinksToExternalResources_Class,
    protein_fractionCovered_Unfiltered : number,
    psmCountForUnfiltered : number,
    modificationMass_UserSelections_ComponentData : ModificationMass_UserSelections_ComponentData,
    modificationMass_OpenModMassZeroNotOpenMod_UserSelection_ComponentData : ModificationMass_OpenModMassZeroNotOpenMod_UserSelection_ComponentData
    reporterIons_UserSelections_ComponentData : ReporterIonMass_UserSelections_ComponentData,
    peptideUnique_UserSelection_ComponentData : PeptideUnique_UserSelection_ComponentData;
    peptideSequence_UserSelections_ComponentData : PeptideSequence_UserSelections_ComponentData,
    userSearchString_LocationsOn_ProteinSequence_Root : UserSearchString_LocationsOn_ProteinSequence_Root,
    proteinSequenceWidgetDisplay_Component_Data : ProteinSequenceWidgetDisplay_Component_Data
    sequenceCoverageBooleanArray_Unfiltered : Array<boolean>,
    reportedPeptideIds_AndTheir_PSM_IDs__AllProjectSearchIds : Peptide__single_protein_getReportedPeptideIds_From_SelectionCriteria_AllProjectSearchIds
}>
{
    try {
        const searchDetailsAndFilterBlock_MainPage_Root_Props_PropValue : SearchDetailsAndFilterBlock_MainPage_Root_Props_PropValue = compute_searchDetailsAndFilterBlock_MainPage_Root_Props_PropValue({ propsValue });

        const searchSubGroup_Ids_Selected : Set<number> = compute_searchSubGroup_Ids_Selected({ propsValue });

        const searchSubGroup_Are_All_SearchSubGroupIds_Selected : boolean = compute_searchSubGroup_Are_All_SearchSubGroupIds_Selected({ propsValue });

        const searchSubGroup_PropValue: SearchSubGroup_In_SearchDetailsAndFilter_Component_DisplayData = compute_searchSubGroup_PropValue({ propsValue });

        const modificationMass_UserSelections_ComponentData = await create_ModificationMass_UserSelections_ComponentData({
            modificationMass_UserSelections_StateObject,
            proteinSequenceVersionId,
            projectSearchIds,
            commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root
        });

        const modificationMass_OpenModMassZeroNotOpenMod_UserSelection_ComponentData = await create_modificationMass_OpenModMassZeroNotOpenMod_UserSelection_ComponentData({
            modificationMass_OpenModMassZeroNotOpenMod_UserSelection__CentralStateManagerObjectClass,
            projectSearchIds,
            commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root
        })

        const reporterIons_UserSelections_ComponentData = await create_ReporterIons_UserSelections_ComponentData({

            reporterIonMass_UserSelections_StateObject,
            projectSearchIds,
            commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root
        });

        const peptideUnique_UserSelection_ComponentData : PeptideUnique_UserSelection_ComponentData = peptideUnique_UserSelection_BuildData_ForReactComponent({
            peptideUnique_UserSelection_StateObject
        })

        const peptideSequence_UserSelections_ComponentData : PeptideSequence_UserSelections_ComponentData = create_PeptideSequence_UserSelections_ComponentData({

            peptideSequence_UserSelections_StateObject
        });

        //  Create initial instance.  Updated instance will be created in peptideSequence_UserSelections.tsx when user changes the input field value
        const userSearchString_LocationsOn_ProteinSequence_Root : UserSearchString_LocationsOn_ProteinSequence_Root = userSearchString_LocationsOn_ProteinSequence_Compute({
            proteinSequenceString,
            searchStrings : peptideSequence_UserSelections_StateObject.getPeptideSearchStrings()
        });

        const getReportedPeptideIdsForDisplay_AllProjectSearchIds_ReturnPromise_result = await getReportedPeptideIdsForDisplay_AllProjectSearchIds_Object.getReportedPeptideIdsForDisplay_AllProjectSearchIds_ReturnPromise({
            not_filtered_position_modification_selections : false,
            proteinSequenceVersionId,
            searchSubGroup_Ids_Selected,
            proteinSequenceWidget_StateObject,
            modificationMass_UserSelections_StateObject,
            modificationMass_OpenModMassZeroNotOpenMod_UserSelection__CentralStateManagerObjectClass,
            reporterIonMass_UserSelections_StateObject,
            scanFilenameId_On_PSM_Filter_UserSelection_StateObject,
            scanNumber_ScanFilenameId_ProjectSearchId_On_PSM_Filter_UserSelection_StateObject,
            scanPeak_M_Over_Z__Intensity_Filter_UserSelection_StateObject,
            scan_RetentionTime_MZ_UserSelection_StateObject,
            psm_Charge_Filter_UserSelection_StateObject,
            peptideUnique_UserSelection_StateObject,
            peptideSequence_UserSelections_StateObject,
            peptideSequence_MissedCleavageCount_UserSelections_StateObject,
            peptideMeetsDigestion_AKA_TrypticPeptide_Etc_UserSelections_StateObject,
            userSearchString_LocationsOn_ProteinSequence_Root,
            proteinPositionFilter_UserSelections_StateObject : undefined,
            proteinPosition_Of_Modification_Filter_UserSelections_StateObject: undefined,
            psm_Exclude_IndependentDecoy_PSMs_Filter_UserSelection_StateObject: undefined
        });

        const reportedPeptideIds_AndTheir_PSM_IDs__AllProjectSearchIds : Peptide__single_protein_getReportedPeptideIds_From_SelectionCriteria_AllProjectSearchIds =
            getReportedPeptideIdsForDisplay_AllProjectSearchIds_ReturnPromise_result.reportedPeptideIds_AndTheir_PSM_IDs__AllProjectSearchIds;


        const sequenceCoverageBooleanArray_Unfiltered = await getSequenceCoverageBooleanArray_NotFiltered({
            proteinSequenceVersionId,
            commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root,
            projectSearchIds
        });

        let proteinSequenceWidgetDisplay_Component_Data : ProteinSequenceWidgetDisplay_Component_Data = undefined;

        {
            let proteinPositions_CoveredBy_SearchStrings = userSearchString_LocationsOn_ProteinSequence_Root.proteinPositions_CoveredBy_SearchStrings;
            if ( proteinPositions_CoveredBy_SearchStrings.length < 1 ) {
                proteinPositions_CoveredBy_SearchStrings = undefined;
            }

            proteinSequenceWidgetDisplay_Component_Data = await create_ProteinSequenceWidgetDisplay_Component_Data({

                proteinSequenceWidget_StateObject,

                reportedPeptideIds_AndTheir_PSM_IDs__AllProjectSearchIds,

                proteinSequenceVersionId,
                proteinSequenceString,
                projectSearchIds,
                proteinCoverageArrayOfBoolean : sequenceCoverageBooleanArray_Unfiltered, //  All Peptides
                proteinPositions_CoveredBy_PeptideSearchStrings: proteinPositions_CoveredBy_SearchStrings,  //  User entered a Peptide String and these Protein Positions are covered by matched peptides - Array of boolean
                commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root,
                modificationMass_UserSelections_StateObject,
                reporterIonMass_UserSelections_StateObject,
                peptideUnique_UserSelection_StateObject,
                peptideSequence_MissedCleavageCount_UserSelections_StateObject,
                peptideMeetsDigestion_AKA_TrypticPeptide_Etc_UserSelections_StateObject,
                peptideList_PeptidePage_SingleProtein_FilterOnCounts_psm_UserSelections_StateObject,
                scanFilenameId_On_PSM_Filter_UserSelection_StateObject,
                scan_RetentionTime_MZ_UserSelections_StateObject: scan_RetentionTime_MZ_UserSelection_StateObject,
                psm_Charge_Filter_UserSelection_StateObject,
                searchSubGroup_Are_All_SearchSubGroupIds_Selected
            });
        }

        const linksToExternalResources = await _createProteinPage_Display__SingleProtein_MainContent_Component_nonClass_Functions__LinksToExternalResources_Class({
            proteinSequenceVersionId, proteinSequenceString, projectSearchIds, commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root
        });

        const protein_fractionCovered_Unfiltered = _computeSequenceCoverageFractionForUnfiltered({ proteinSequenceString, sequenceCoverageBooleanArray_Unfiltered });

        const psmCountForUnfiltered = await _computePsmCountForUnfiltered({ proteinSequenceVersionId, projectSearchIds, commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root });

        return {
            searchDetailsAndFilterBlock_MainPage_Root_Props_PropValue,
            searchSubGroup_Ids_Selected,
            searchSubGroup_Are_All_SearchSubGroupIds_Selected,
            searchSubGroup_PropValue,
            linksToExternalResources,
            protein_fractionCovered_Unfiltered,
            psmCountForUnfiltered,
            modificationMass_UserSelections_ComponentData,
            modificationMass_OpenModMassZeroNotOpenMod_UserSelection_ComponentData,
            reporterIons_UserSelections_ComponentData,
            peptideUnique_UserSelection_ComponentData,
            peptideSequence_UserSelections_ComponentData,
            userSearchString_LocationsOn_ProteinSequence_Root,
            proteinSequenceWidgetDisplay_Component_Data,
            sequenceCoverageBooleanArray_Unfiltered,
            reportedPeptideIds_AndTheir_PSM_IDs__AllProjectSearchIds
        }

    } catch (e) { reportWebErrorToServer.reportErrorObjectToServer({errorException: e}); throw e }
}        

///////////////////////////

/**
 * Create searchSubGroup_Ids_Selected
 */
const compute_searchSubGroup_Ids_Selected = function (
    {
        propsValue
    } : {
        propsValue : ProteinPage_Display__SingleProtein_MainContent_Component_Props_Prop
    }) :  Set<number>
{
    if ( ! propsValue.searchSubGroup_CentralStateManagerObjectClass ) {
        // If NO Page State Object, nothing can be selected
        return undefined;
    }

    let searchSubGroup_Ids_Selected : Set<number> = undefined;

    if ( propsValue.projectSearchIds.length === 1 && propsValue.dataPageStateManager.get_SearchSubGroups_Root() ) {

        //  Only display for 1 search

        const projectSearchId = propsValue.projectSearchIds[ 0 ];

        const searchSubGroups_ForProjectSearchId = propsValue.dataPageStateManager.get_SearchSubGroups_Root().get_searchSubGroups_ForProjectSearchId( projectSearchId );
        if ( ! searchSubGroups_ForProjectSearchId ) {
            const msg = "returned nothing: propsValue.dataPageStateManager.get_SearchSubGroups_Root().get_searchSubGroups_ForProjectSearchId( projectSearchId ), projectSearchId: " + projectSearchId;
            console.warn( msg )
            throw Error( msg )
        }

        searchSubGroup_Ids_Selected = searchSubGroup_Get_Selected_SearchSubGroupIds({
            searchSubGroup_CentralStateManagerObjectClass : propsValue.searchSubGroup_CentralStateManagerObjectClass, searchSubGroups_ForProjectSearchId
        })
    }

    return searchSubGroup_Ids_Selected;
}

/**
 * Create searchSubGroup_Are_All_SearchSubGroupIds_Selected
 */
const compute_searchSubGroup_Are_All_SearchSubGroupIds_Selected = function (
    {
        propsValue
    } : {
        propsValue : ProteinPage_Display__SingleProtein_MainContent_Component_Props_Prop
    }) :  boolean
{
    let searchSubGroup_Are_All_SearchSubGroupIds_Selected : boolean = true; // Default to true for when Merged Search or No Search SUb Groups

    if ( propsValue.projectSearchIds.length === 1 && propsValue.dataPageStateManager.get_SearchSubGroups_Root() ) {

        //  Only display for 1 search

        const projectSearchId = propsValue.projectSearchIds[ 0 ];

        const searchSubGroups_ForProjectSearchId = propsValue.dataPageStateManager.get_SearchSubGroups_Root().get_searchSubGroups_ForProjectSearchId( projectSearchId );
        if ( ! searchSubGroups_ForProjectSearchId ) {
            const msg = "returned nothing: propsValue.dataPageStateManager.get_SearchSubGroups_Root().get_searchSubGroups_ForProjectSearchId( projectSearchId ), projectSearchId: " + projectSearchId;
            console.warn( msg )
            throw Error( msg )
        }

        searchSubGroup_Are_All_SearchSubGroupIds_Selected = searchSubGroup_Are_All_SearchSubGroupIds_Selected__Fcn({
            searchSubGroup_CentralStateManagerObjectClass : propsValue.searchSubGroup_CentralStateManagerObjectClass, searchSubGroups_ForProjectSearchId
        })
    }

    return searchSubGroup_Are_All_SearchSubGroupIds_Selected;
}

/**
 * Create searchDetailsAndFilterBlock_MainPage_Root_Props_PropValue
 */
const compute_searchSubGroup_PropValue = function (
    {
        propsValue
    } : {
        propsValue : ProteinPage_Display__SingleProtein_MainContent_Component_Props_Prop

    }) : SearchSubGroup_In_SearchDetailsAndFilter_Component_DisplayData {

    let searchSubGroup_PropValue: SearchSubGroup_In_SearchDetailsAndFilter_Component_DisplayData = null;

    if (
        propsValue.searchSubGroup_CentralStateManagerObjectClass
        && propsValue.projectSearchIds.length === 1
        && propsValue.dataPageStateManager.get_SearchSubGroups_Root() ) {

        //  Only display for 1 search

        const projectSearchId = propsValue.projectSearchIds[ 0 ];

        const searchSubGroups_ForProjectSearchId = propsValue.dataPageStateManager.get_SearchSubGroups_Root().get_searchSubGroups_ForProjectSearchId( projectSearchId );
        if ( ! searchSubGroups_ForProjectSearchId ) {
            const msg = "returned nothing: propsValue.dataPageStateManager.get_SearchSubGroups_Root().get_searchSubGroups_ForProjectSearchId( projectSearchId ), projectSearchId: " + projectSearchId;
            console.warn( msg )
            throw Error( msg )
        }

        searchSubGroup_PropValue = searchSubGroup_Create__SearchSubGroup_In_SearchDetailsAndFilter_Component_DisplayData({
            searchSubGroups_EntryFor_ProjectSearchId__DataPageStateManagerEntry : searchSubGroups_ForProjectSearchId,
            searchSubGroup_CentralStateManagerObjectClass: propsValue.searchSubGroup_CentralStateManagerObjectClass
        });
    }

    return searchSubGroup_PropValue;
}


/**
 * Create searchDetailsAndFilterBlock_MainPage_Root_Props_PropValue
 */
const compute_searchDetailsAndFilterBlock_MainPage_Root_Props_PropValue = function (
    {
        propsValue
    } : {
        propsValue : ProteinPage_Display__SingleProtein_MainContent_Component_Props_Prop

    }) : SearchDetailsAndFilterBlock_MainPage_Root_Props_PropValue
{

    let searchSubGroup_PropValue : SearchSubGroup_In_SearchDetailsAndFilter_Component_DisplayData = undefined;

    const searchDetailsAndFilterBlock_MainPage_Root_Props_PropValue : SearchDetailsAndFilterBlock_MainPage_Root_Props_PropValue =  {
        displayOnly : true,
        isProteinPage: false,
        dataPages_LoggedInUser_CommonObjectsFactory : propsValue.dataPages_LoggedInUser_CommonObjectsFactory,
        dataPageStateManager_ProjectSearchIdsTheirFiltersAnnTypeDisplay : propsValue.dataPageStateManager_ProjectSearchIdsTheirFiltersAnnTypeDisplay,
        dataPageStateManager_DataFrom_Server : propsValue.dataPageStateManager,
        searchDetailsBlockDataMgmtProcessing : propsValue.searchDetailsBlockDataMgmtProcessing,
        filterValuesChanged_Callback : undefined,
        callback_Before_ReadURLtoGenerateNewURL_ReOrderSearchesOverlay: undefined,
        searchSubGroup_PropValue,
        limelight_Colors_For_MultipleSearches: undefined
    }

    return searchDetailsAndFilterBlock_MainPage_Root_Props_PropValue;
}


/**
 * Create links to external resources
 */
const _createProteinPage_Display__SingleProtein_MainContent_Component_nonClass_Functions__LinksToExternalResources_Class = async function({
    
    proteinSequenceVersionId, 
    proteinSequenceString, 
    projectSearchIds, 
    commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root
} : {
    proteinSequenceVersionId : number, 
    proteinSequenceString : string, 
    projectSearchIds : Array<number>,
    commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root: CommonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root

}) : Promise<ProteinPage_Display__SingleProtein_MainContent_Component_nonClass_Functions__LinksToExternalResources_Class> {
    try {
        const NCBI_Blast_URL = "https://blast.ncbi.nlm.nih.gov/Blast.cgi?PAGE=Proteins&QUERY=" + proteinSequenceString;
        const PDR_Blast_URL = "https://yeastrc.org/pdr/blastSearchInit.do?query=" + proteinSequenceString;

        const proteinNames_URI_Encoded_Set = new Set();

        for ( const projectSearchId of projectSearchIds ) {

            const commonData_LoadedFromServer_PerSearch_For_ProjectSearchId =
                commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root.get__commonData_LoadedFromServer_PerSearch_For_ProjectSearchId(projectSearchId)

            if ( ! commonData_LoadedFromServer_PerSearch_For_ProjectSearchId ) {
                const msg = "_createProteinPage_Display__SingleProtein_MainContent_Component_nonClass_Functions__LinksToExternalResources_Class(): No value in commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root for projectSearchId: " + projectSearchId;
                console.warn( msg );
                throw Error( msg );
            }

            const get_ProteinInfoHolder_AllForSearch_ReturnPromise_Result = await
            commonData_LoadedFromServer_PerSearch_For_ProjectSearchId.
            get_commonData_LoadedFromServer_SingleSearch__ProteinInfo_For_MainFilters().
            get_ProteinInfoHolder_AllForSearch_ReturnPromise();

            const proteinInfo_For_MainFilters_Holder = get_ProteinInfoHolder_AllForSearch_ReturnPromise_Result.proteinInfo_For_MainFilters_Holder

            const proteinInfo = proteinInfo_For_MainFilters_Holder.get_ProteinInfo_For_ProteinSequenceVersionId( proteinSequenceVersionId );
            if ( proteinInfo ) {
                const annotations = proteinInfo.annotations;
                if ( annotations ) {
                    for ( const annotation of annotations ) {
                        const name = annotation.name;
                        //				const description = annotation.description;
                        //				const taxonomy = annotation.taxonomy;
                        const proteinName_URI_Encoded = window.encodeURIComponent( name );
                        proteinNames_URI_Encoded_Set.add( proteinName_URI_Encoded );
                    }
                }
            }
        }

        if ( proteinNames_URI_Encoded_Set.size === 0 ) {
            throw Error("No Protein names found for any searches.");
        }

        const proteinNames_URI_Encoded_Array = Array.from( proteinNames_URI_Encoded_Set );

        const proteinNamesForQueries = proteinNames_URI_Encoded_Array.join("+or+");

        // (if more than one name for this sequence, separate they by "+or+")
        const UniProtKB_Search_URL ="https://www.uniprot.org/uniprot/?query=" + proteinNamesForQueries + "&sort=score";

        const NCBI_Search_URL ="https://www.ncbi.nlm.nih.gov/protein/?term=" + proteinNamesForQueries;


        const linksToExternalResources = {
            NCBI_Blast_URL,
            PDR_Blast_URL,
            UniProtKB_Search_URL,
            NCBI_Search_URL
        }

        return linksToExternalResources;

    } catch (e) { reportWebErrorToServer.reportErrorObjectToServer({errorException: e}); throw e }
}


/**
 * Create links to external resources
 */
const _computeSequenceCoverageFractionForUnfiltered = function({ 
    
    proteinSequenceString, 
    sequenceCoverageBooleanArray_Unfiltered 
} : { 
    proteinSequenceString : string, 
    sequenceCoverageBooleanArray_Unfiltered : Array<boolean>
}) : number {

    //  Array of data is 1 based for protein position that starts at 1

    const proteinSequenceString_length = proteinSequenceString.length;

    let positionsCoveredCount = 0;

    for ( let position = 1; position <= proteinSequenceString_length; position++ ) {
        if ( sequenceCoverageBooleanArray_Unfiltered[ position ] ) {
            positionsCoveredCount++;
        }
    }

    const fractionCovered = ( positionsCoveredCount / proteinSequenceString_length )

    return fractionCovered;
}


/**
 * Compute PSM Count for Protein for All Project Search Ids - No Filtering for any user choices on this single protein or in protein list
 */
const _computePsmCountForUnfiltered = async function({
    
    proteinSequenceVersionId, 
    projectSearchIds, 
    commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root
} : {
    proteinSequenceVersionId : number, 
    projectSearchIds : Array<number>,
    commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root: CommonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root

}) : Promise<number> {
    try {
        let psmCount = 0;

        for ( const projectSearchId of projectSearchIds ) {

            const commonData_LoadedFromServer_PerSearch_For_ProjectSearchId =
                commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root.get__commonData_LoadedFromServer_PerSearch_For_ProjectSearchId( projectSearchId );
            if ( ! commonData_LoadedFromServer_PerSearch_For_ProjectSearchId ) {
                //  No entry for this projectSearchId
                continue; // EARLY CONTINUE
            }

            const get_ProteinSequenceVersionIds_And_ProteinCoverage_AllForSearch_ReturnPromise_Result =
                await commonData_LoadedFromServer_PerSearch_For_ProjectSearchId.
                get_commonData_LoadedFromServer_SingleSearch__ProteinSequenceVersionIds_And_ProteinCoverage_From_ReportedPeptidePeptideIds_For_MainFilters().
                get_ProteinSequenceVersionIds_And_ProteinCoverage_AllForSearch_ReturnPromise();
            const proteinSequenceVersionIds_And_ProteinCoverage_For_MainFilters_Holder = get_ProteinSequenceVersionIds_And_ProteinCoverage_AllForSearch_ReturnPromise_Result.proteinSequenceVersionIds_And_ProteinCoverage_For_MainFilters_Holder

            const reportedPeptideIds = proteinSequenceVersionIds_And_ProteinCoverage_For_MainFilters_Holder.get_reportedPeptideIds_For_ProteinSequenceVersionId( proteinSequenceVersionId );
            if ( ! reportedPeptideIds ) {
                //  No entry
                continue; // EARLY CONTINUE
            }

            const get_numPsmsForReportedPeptideIdMap_ReturnPromise_Result =
                await commonData_LoadedFromServer_PerSearch_For_ProjectSearchId.
                get_commonData_LoadedFromServer_SingleSearch__ReportedPeptideId_Based_Data_For_MainFilters().get_numPsmsForReportedPeptideIdMap_ReturnPromise();

            const numPsmsForReportedPeptideIdMap = get_numPsmsForReportedPeptideIdMap_ReturnPromise_Result.numPsmsForReportedPeptideIdMap

            for ( const reportedPeptideId of reportedPeptideIds ) {
                const numPsmsForReportedPeptideId = numPsmsForReportedPeptideIdMap.get( reportedPeptideId );
                if ( numPsmsForReportedPeptideId ) {
                    psmCount += numPsmsForReportedPeptideId;
                }
            }
        }

        return psmCount;

    } catch (e) { reportWebErrorToServer.reportErrorObjectToServer({errorException: e}); throw e }
}

///////////////////////////

/**
 * 
 */
const create_ModificationMass_UserSelections_ComponentData = async function({

    modificationMass_UserSelections_StateObject,
    proteinSequenceVersionId,
    projectSearchIds,
    commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root
} : {
    modificationMass_UserSelections_StateObject : ModificationMass_UserSelections_StateObject,
    proteinSequenceVersionId : number,
    projectSearchIds : Array<number>,
    commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root: CommonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root
}) : Promise<ModificationMass_UserSelections_ComponentData> {
    try {
        let modificationMass_CommonRounding_ReturnNumber_Param = modificationMass_CommonRounding_ReturnNumber;

        const modificationMass_UserSelections_ComponentData = modificationMass_UserSelections_BuildData_ForReactComponent({
            modificationMass_UserSelections_StateObject : modificationMass_UserSelections_StateObject,
            proteinSequenceVersionId : proteinSequenceVersionId,
            projectSearchIds : projectSearchIds,
            commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root,
            modificationMass_CommonRounding_ReturnNumber : modificationMass_CommonRounding_ReturnNumber_Param
        });

        return modificationMass_UserSelections_ComponentData;

    } catch (e) { reportWebErrorToServer.reportErrorObjectToServer({errorException: e}); throw e }
}

/**
 *
 */
const create_modificationMass_OpenModMassZeroNotOpenMod_UserSelection_ComponentData = async function(
    {
        modificationMass_OpenModMassZeroNotOpenMod_UserSelection__CentralStateManagerObjectClass,
        projectSearchIds,
        commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root
    } : {
        modificationMass_OpenModMassZeroNotOpenMod_UserSelection__CentralStateManagerObjectClass : ModificationMass_OpenModMassZeroNotOpenMod_UserSelection__CentralStateManagerObjectClass
        projectSearchIds : Array<number>
        commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root: CommonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root

    }) : Promise<ModificationMass_OpenModMassZeroNotOpenMod_UserSelection_ComponentData> {
    try {
        const modificationMass_OpenModMassZeroNotOpenMod_UserSelection_Build_ComponentData_ForReactComponent_Result = modificationMass_OpenModMassZeroNotOpenMod_UserSelection_Build_ComponentData_ForReactComponent({
            modificationMass_OpenModMassZeroNotOpenMod_UserSelection__CentralStateManagerObjectClass,
            projectSearchIds,
            commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root
        });

        if ( modificationMass_OpenModMassZeroNotOpenMod_UserSelection_Build_ComponentData_ForReactComponent_Result.promise ) {

            return modificationMass_OpenModMassZeroNotOpenMod_UserSelection_Build_ComponentData_ForReactComponent_Result.promise
        } else if ( modificationMass_OpenModMassZeroNotOpenMod_UserSelection_Build_ComponentData_ForReactComponent_Result.data ) {
            return Promise.resolve(modificationMass_OpenModMassZeroNotOpenMod_UserSelection_Build_ComponentData_ForReactComponent_Result.data)
        } else {
            throw Error("modificationMass_OpenModMassZeroNotOpenMod_UserSelection_Build_ComponentData_ForReactComponent_Result no promise or data")
        }

        console.warn("SHOULD NOT GET HERE")
        throw Error("SHOULD NOT GET HERE")

    } catch (e) { reportWebErrorToServer.reportErrorObjectToServer({errorException: e}); throw e }
}

/**
 * 
 */
const create_ReporterIons_UserSelections_ComponentData = async function( {

    reporterIonMass_UserSelections_StateObject,
    projectSearchIds,
    commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root
} : {
    reporterIonMass_UserSelections_StateObject : ReporterIonMass_UserSelections_StateObject,
    projectSearchIds : Array<number>,
    commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root: CommonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root

}) : Promise<ReporterIonMass_UserSelections_ComponentData> {
    try {
        let reporterIonMass_CommonRounding_ReturnNumber_Param = reporterIonMass_CommonRounding_ReturnNumber;

        const reporterIons_UserSelections_ComponentData = reporterIonMass_UserSelections_BuildData_ForReactComponent({

            reporterIonMass_UserSelections_StateObject : reporterIonMass_UserSelections_StateObject,
            projectSearchIds : projectSearchIds,
            commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root,
            reporterIonMass_CommonRounding_ReturnNumber : reporterIonMass_CommonRounding_ReturnNumber_Param // Always passed for Experiment - Made a parameter to make easier to copy this code for Protein Page Single Search
        });

        return reporterIons_UserSelections_ComponentData;

    } catch (e) { reportWebErrorToServer.reportErrorObjectToServer({errorException: e}); throw e }
}

/**
 * 
 */
const create_PeptideSequence_UserSelections_ComponentData = function( {

    peptideSequence_UserSelections_StateObject
} : {
    peptideSequence_UserSelections_StateObject : PeptideSequence_UserSelections_StateObject,
}) : PeptideSequence_UserSelections_ComponentData {

    const peptideSequence_UserSelections_ComponentData = peptideSequence_UserSelections_BuildData_ForReactComponent({ 

        peptideSequence_UserSelections_StateObject : peptideSequence_UserSelections_StateObject
    });

    return peptideSequence_UserSelections_ComponentData;
}

/**
 * 'async function'
 */
const create_ProteinSequenceWidgetDisplay_Component_Data = async function({

    proteinSequenceWidget_StateObject,

    reportedPeptideIds_AndTheir_PSM_IDs__AllProjectSearchIds,

    proteinSequenceVersionId,
    proteinSequenceString,
    projectSearchIds,
    proteinCoverageArrayOfBoolean, //  All Peptides
    proteinPositions_CoveredBy_PeptideSearchStrings,
    commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root,
    modificationMass_UserSelections_StateObject,
    reporterIonMass_UserSelections_StateObject,
    peptideUnique_UserSelection_StateObject,
    peptideSequence_MissedCleavageCount_UserSelections_StateObject,
    peptideMeetsDigestion_AKA_TrypticPeptide_Etc_UserSelections_StateObject,
    peptideList_PeptidePage_SingleProtein_FilterOnCounts_psm_UserSelections_StateObject,
    scanFilenameId_On_PSM_Filter_UserSelection_StateObject,
    scan_RetentionTime_MZ_UserSelections_StateObject,
    psm_Charge_Filter_UserSelection_StateObject,
    searchSubGroup_Are_All_SearchSubGroupIds_Selected
} : {
    proteinSequenceWidget_StateObject : ProteinSequenceWidget_StateObject

    reportedPeptideIds_AndTheir_PSM_IDs__AllProjectSearchIds : Peptide__single_protein_getReportedPeptideIds_From_SelectionCriteria_AllProjectSearchIds

    proteinSequenceVersionId : number
    proteinSequenceString : string
    projectSearchIds : Array<number>
    proteinCoverageArrayOfBoolean : Array<boolean> //  All Peptides
    proteinPositions_CoveredBy_PeptideSearchStrings : Array<boolean>
    commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root: CommonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root
    modificationMass_UserSelections_StateObject : ModificationMass_UserSelections_StateObject
    reporterIonMass_UserSelections_StateObject : ReporterIonMass_UserSelections_StateObject
    peptideUnique_UserSelection_StateObject : PeptideUnique_UserSelection_StateObject;
    peptideSequence_MissedCleavageCount_UserSelections_StateObject : PeptideSequence_MissedCleavageCount_UserSelections_StateObject
    peptideMeetsDigestion_AKA_TrypticPeptide_Etc_UserSelections_StateObject: PeptideMeetsDigestion_AKA_TrypticPeptide_Etc_UserSelections_StateObject;
    peptideList_PeptidePage_SingleProtein_FilterOnCounts_psm_UserSelections_StateObject : PeptideList_PeptidePage_SingleProtein_FilterOnCounts_psm_UserSelections_StateObject
    scanFilenameId_On_PSM_Filter_UserSelection_StateObject : ScanFilenameId_On_PSM_Filter_UserSelection_StateObject
    scan_RetentionTime_MZ_UserSelections_StateObject : Scan_RetentionTime_MZ_UserSelections_StateObject
    psm_Charge_Filter_UserSelection_StateObject : Psm_Charge_Filter_UserSelection_StateObject
    searchSubGroup_Are_All_SearchSubGroupIds_Selected : boolean

}) : Promise<ProteinSequenceWidgetDisplay_Component_Data> {
    try {
        let sequenceCoverageBooleanArray_ForReportedPeptideIds : Array<boolean> = null;

        if (
            modificationMass_UserSelections_StateObject.get_VariableModificationSelections().is_Any_Modification_Selected()
            || modificationMass_UserSelections_StateObject.get_OpenModificationSelections().is_Any_Modification_Selected()
            || modificationMass_UserSelections_StateObject.is_Any_StaticModification_Selected()
            || reporterIonMass_UserSelections_StateObject.is_Any_ReporterIons_Selected()
            || peptideUnique_UserSelection_StateObject.getPeptideUnique()
            || peptideSequence_MissedCleavageCount_UserSelections_StateObject.is_Any_FilterHaveValue()
            || proteinPositions_CoveredBy_PeptideSearchStrings
            || proteinSequenceWidget_StateObject.is_Any_selectedProteinSequencePosition()
            || proteinSequenceWidget_StateObject.is_Any_selected_Protein_StartEnd_Position()
            || peptideMeetsDigestion_AKA_TrypticPeptide_Etc_UserSelections_StateObject.get_PeptideMeetsDigestion_AKA_TrypticPeptide_Etc_UserSelection() !== PeptideMeetsDigestion_AKA_TrypticPeptide_Etc_UserSelections_StateObject__SelectionEnum.NONE
            || ( peptideList_PeptidePage_SingleProtein_FilterOnCounts_psm_UserSelections_StateObject.get_PSM_CountFilter() !== undefined && peptideList_PeptidePage_SingleProtein_FilterOnCounts_psm_UserSelections_StateObject.get_PSM_CountFilter() !== null )
            || ( ! scanFilenameId_On_PSM_Filter_UserSelection_StateObject.areAllSelected__scanFilenameIds() )
            || scan_RetentionTime_MZ_UserSelections_StateObject && scan_RetentionTime_MZ_UserSelections_StateObject.is_Any_FilterHaveValue()
            || ( ! psm_Charge_Filter_UserSelection_StateObject.areAllSelected__chargeValues_OnPSMs() )
            || ( ! searchSubGroup_Are_All_SearchSubGroupIds_Selected )
        ) {
            //  Populate since have user selection
            sequenceCoverageBooleanArray_ForReportedPeptideIds = await getSequenceCoverageBooleanArray_ForReportedPeptideIds({

                reportedPeptideIds_AndTheir_PSM_IDs__AllProjectSearchIds,
                proteinSequenceVersionId,
                commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root,
                projectSearchIds
            });
        }

        //    Modification Mass Info for display

        //  Format for class ProteinSequenceFormattedDisplay_Main_displayWidget:  mods per sequence position:  Map < {integer: position 1 based} : [ <mass> ] >.
        const variableModificationMassesForProteinPositions = await _get_variableModificationMasses_All_OnProteinByPosition({
            proteinSequenceVersionId,
            projectSearchIds,
            commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root
        });

        //  Format for class ProteinSequenceFormattedDisplay_Main_displayWidget:  mods per sequence position:  // Map <integer, Map<integer, Object> <proteinSequenceVersionId, Map < position 1 based (integer) : { Object: residue  (string), masses: [ mass (number) ] } >>
        const staticModificationMassesForProteinPositions : ProteinSequenceWidgetDisplay_Component_Data__Build__staticModificationMassesForProteinPositions_PARAM =
            await _get_staticModificationMasses_All_OnProteinByPosition({
                proteinSequenceVersionId : proteinSequenceVersionId,
                projectSearchIds : projectSearchIds,
                commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root
            });

        const staticModificationMassesToFilterOn = modificationMass_UserSelections_StateObject.get_StaticModifications_Selected_Residue_Mass_Map_Set();

        const variableModificationSelectionUnmodifiedSelected = modificationMass_UserSelections_StateObject.get_VariableModificationSelections().is_NO_Modification_AKA_Unmodified_Selected();
        const variableModificationMassesToFilterOn = modificationMass_UserSelections_StateObject.get_VariableModificationSelections().get_ModificationsSelected__OnlyModMasses_AsSet();


        const proteinSequenceWidgetDisplay_Component_Data = proteinSequenceWidgetDisplay_Component_Data__Build({  //  External Function Call
            proteinSequenceString,
            proteinSequenceWidget_StateObject : proteinSequenceWidget_StateObject,
            proteinCoverageArrayOfBoolean,
            proteinCoverageArrayOfBoolean_UserSelectedPeptides : sequenceCoverageBooleanArray_ForReportedPeptideIds,  // - null or undefined if not set - Only User Selected Peptides
            variableModificationSelectionUnmodifiedSelected,
            variableModificationMassesToFilterOn,
            staticModificationMassesToFilterOn : staticModificationMassesToFilterOn,
            variableModificationMassesForProteinPositions,
            staticModificationMassesForProteinPositions,
            proteinPositions_CoveredBy_PeptideSearchStrings  //  User entered a Peptide String and these Protein Positions are covered by matched peptides - Array of boolean
        });

        return proteinSequenceWidgetDisplay_Component_Data;

    } catch (e) { reportWebErrorToServer.reportErrorObjectToServer({errorException: e}); throw e }
}


////////////////////////////////////////////////////////



/////////

//  Modification Mass Info for display


//  Format for class ProteinSequenceFormattedDisplay_Main_displayWidget:  mods per sequence position:  Map < {integer: position 1 based} : [ <mass> ] >.

/**
 * All Variable modification masses by protein position
 * 
 * @returns  Map < {integer: position 1 based} : [ <mass> ] > -- Format for class ProteinSequenceFormattedDisplay_Main_displayWidget:
 */
const _get_variableModificationMasses_All_OnProteinByPosition = function(
    {
        proteinSequenceVersionId, projectSearchIds, commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root
    }: {
        proteinSequenceVersionId: number
        projectSearchIds: Array<number>
        commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root: CommonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root
    }) : Promise<Map<number, Array<number>>> {

    //  Start with Map of Sets to remove duplicates  -  Passed to Processing for Each Search where it is updated
    const modsOnProteinByPosition_Sets: Map<number, Set<number>> = new Map(); // mods per sequence position:  Set < {integer: position 1 based} : [ <mass> ] >.

    const promises: Array<Promise<void>> = []

    for ( const projectSearchId of projectSearchIds ) {

        const commonData_LoadedFromServer_PerSearch_For_ProjectSearchId = commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root.get__commonData_LoadedFromServer_PerSearch_For_ProjectSearchId(projectSearchId)

        //  promise is null if no promise
        const promise = _get_variableModificationMasses_All_OnProteinByPosition__LoadDataAndProcess__SingleSearch({
            proteinSequenceVersionId, modsOnProteinByPosition_Sets, commonData_LoadedFromServer_PerSearch_For_ProjectSearchId
        })
        if ( promise ) {
            promises.push(promise)
        }
    }

    if ( promises.length === 0 ) {

        //  Processing for Each Search is complete,  Create final result and return it

        const modsOnProteinByPosition =
            _get_variableModificationMasses_All_OnProteinByPosition__Process_AfterAllSearches({modsOnProteinByPosition_Sets})

        //   Returned Promise
        return Promise.resolve(modsOnProteinByPosition);  //  EARLY RETURN  //  Return resolved Promise
    }

    const promises_All = Promise.all(promises);

    //   Returned Promise
    return new Promise<Map<number, Array<number>>>((resolve, reject) => { try {
        promises_All.catch(reason => {reject(reason)})
        promises_All.then(noValue => { try {

            //  Processing for Each Search is complete,  Create final result and return it

            const modsOnProteinByPosition = _get_variableModificationMasses_All_OnProteinByPosition__Process_AfterAllSearches({modsOnProteinByPosition_Sets})

            resolve(modsOnProteinByPosition);  //  resolve

        } catch (e) { reportWebErrorToServer.reportErrorObjectToServer({errorException: e}); throw e }})
    } catch (e) { reportWebErrorToServer.reportErrorObjectToServer({errorException: e}); throw e }})
}

/**
 *
 * @param modsOnProteinByPosition_Sets
 * @param commonData_LoadedFromServer_PerSearch_For_ProjectSearchId
 */
const _get_variableModificationMasses_All_OnProteinByPosition__Process_AfterAllSearches = function (
    {
        modsOnProteinByPosition_Sets
    } : {
        modsOnProteinByPosition_Sets: Map<number, Set<number>>
    }) : Map<number, Array<number>> {

    //  Format for class ProteinSequenceFormattedDisplay_Main_displayWidget:
    const modsOnProteinByPosition: Map<number, Array<number>> = new Map(); // mods per sequence position:  Map < {integer: position 1 based} : [ <mass> ] >.

    //  Sort masses at each position
    for ( const modsOnProteinByPositionEntry of modsOnProteinByPosition_Sets.entries() ) {
        const position = modsOnProteinByPositionEntry[ 0 ];
        const massesAtPositionSet = modsOnProteinByPositionEntry[ 1 ];
        const massesAtPositionArray = Array.from( massesAtPositionSet );
        limelight__Sort_ArrayOfNumbers_SortArrayInPlace(massesAtPositionArray);
        //  Place the sorted Array in the final output Map
        modsOnProteinByPosition.set( position, massesAtPositionArray );
    }

    return modsOnProteinByPosition;
}

/**
 *
 * @param modsOnProteinByPosition_Sets
 * @param commonData_LoadedFromServer_PerSearch_For_ProjectSearchId
 */
const _get_variableModificationMasses_All_OnProteinByPosition__LoadDataAndProcess__SingleSearch = function (
    {
        proteinSequenceVersionId, modsOnProteinByPosition_Sets, commonData_LoadedFromServer_PerSearch_For_ProjectSearchId
    } : {
        proteinSequenceVersionId: number
        modsOnProteinByPosition_Sets: Map<number, Set<number>> // mods per sequence position:  Set < {integer: position 1 based} : [ <mass> ] >.
        commonData_LoadedFromServer_PerSearch_For_ProjectSearchId: CommonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Single_ProjectSearchId
    }
) : Promise<void> {
    const get_Variable_Dynamic_Modifications_At_ProteinSequenceVersionId_LevelHolder_AllForSearch_Result =
        commonData_LoadedFromServer_PerSearch_For_ProjectSearchId.
        get_commonData_LoadedFromServer_SingleSearch__Variable_Dynamic_Modifications_At_ProteinSequenceVersionId_Level_For_MainFilters()
        .get_Variable_Dynamic_Modifications_At_ProteinSequenceVersionId_LevelHolder_AllForSearch();

    if ( get_Variable_Dynamic_Modifications_At_ProteinSequenceVersionId_LevelHolder_AllForSearch_Result.data ) {
        _get_variableModificationMasses_All_OnProteinByPosition__AfterLoadData__SingleSearch({
            proteinSequenceVersionId,
            modsOnProteinByPosition_Sets,
            variable_Dynamic_Modifications_At_ProteinSequenceVersionId_Level_For_MainFilters_Holder:
            get_Variable_Dynamic_Modifications_At_ProteinSequenceVersionId_LevelHolder_AllForSearch_Result.data.variable_Dynamic_Modifications_At_ProteinSequenceVersionId_Level_For_MainFilters_Holder
        })
        return null;
    } else if ( get_Variable_Dynamic_Modifications_At_ProteinSequenceVersionId_LevelHolder_AllForSearch_Result.promise ) {
        return new Promise<void>((resolve, reject) => {  try {
            get_Variable_Dynamic_Modifications_At_ProteinSequenceVersionId_LevelHolder_AllForSearch_Result.promise.catch(reason => reject(reason))
            get_Variable_Dynamic_Modifications_At_ProteinSequenceVersionId_LevelHolder_AllForSearch_Result.promise.then(value => { try {
                _get_variableModificationMasses_All_OnProteinByPosition__AfterLoadData__SingleSearch({
                    proteinSequenceVersionId,
                    modsOnProteinByPosition_Sets,
                    variable_Dynamic_Modifications_At_ProteinSequenceVersionId_Level_For_MainFilters_Holder:
                    value.variable_Dynamic_Modifications_At_ProteinSequenceVersionId_Level_For_MainFilters_Holder
                })
                resolve();
            } catch (e) { reportWebErrorToServer.reportErrorObjectToServer({errorException: e}); throw e }})
        } catch (e) { reportWebErrorToServer.reportErrorObjectToServer({errorException: e}); throw e }})
    } else {
        throw Error("get_Variable_Dynamic_Modifications_At_ProteinSequenceVersionId_LevelHolder_AllForSearch_Result no data or promise")
    }
}

/**
 *
 * @param modsOnProteinByPosition_Sets
 * @param variable_Dynamic_Modifications_At_ProteinSequenceVersionId_Level_For_MainFilters_Holder
 */
const _get_variableModificationMasses_All_OnProteinByPosition__AfterLoadData__SingleSearch = function (
    {
        proteinSequenceVersionId, modsOnProteinByPosition_Sets, variable_Dynamic_Modifications_At_ProteinSequenceVersionId_Level_For_MainFilters_Holder
    } : {
        proteinSequenceVersionId: number
        modsOnProteinByPosition_Sets: Map<number, Set<number>> // mods per sequence position:  Set < {integer: position 1 based} : [ <mass> ] >.
        variable_Dynamic_Modifications_At_ProteinSequenceVersionId_Level_For_MainFilters_Holder: CommonData_LoadedFromServer_SingleSearch__Variable_Dynamic_Modifications_At_ProteinSequenceVersionId_Level_For_MainFilters_Holder
    }
) {

    if ( ! variable_Dynamic_Modifications_At_ProteinSequenceVersionId_Level_For_MainFilters_Holder.is_Has_Variable_Dynamic_Modifications_At_ProteinSequenceVersionId_Entries() ) {
        //  No data for projectSearchId so skip to next
        return; // EARLY RETURN
    }

    const dynamicModificationsOnProtein =
        variable_Dynamic_Modifications_At_ProteinSequenceVersionId_Level_For_MainFilters_Holder.
        get_Variable_Dynamic_Modifications_At_ProteinSequenceVersionId_For_ProteinSequenceVersionId( proteinSequenceVersionId );

    if ( ! dynamicModificationsOnProtein ) {
        // No Data for _proteinSequenceVersionId so skip to next
        return; // EARLY RETURN
    }

    for ( const modificationOnProtein of dynamicModificationsOnProtein) {
        //  Currently a single array of all  mods for the protein.  Maybe make it a Map of mods at positions

        //  modificationOnProtein { mass: 9945.99, position: 23, reportedPeptideId: 26043 }

        const position = modificationOnProtein.position;
        const mass = modificationOnProtein.mass;

        let massesAtPosition = modsOnProteinByPosition_Sets.get( position );
        if ( ! massesAtPosition ) {
            massesAtPosition = new Set();
            modsOnProteinByPosition_Sets.set( position, massesAtPosition );
        }
        //  Round mass since Multiple Search
        const roundedMass = _roundModificationMass_ReturnNumber_LocalFunction({ mass });
        massesAtPosition.add( roundedMass );
    }
}

/////////////////////////////////

//  Format for class ProteinSequenceFormattedDisplay_Main_displayWidget:  mods per sequence position:  // Map <integer, Map<integer, Object> <proteinSequenceVersionId, Map < position 1 based (integer) : { Object: residue  (string), masses: [ mass (number) ] } >>

/**
 * All Static modification masses by protein position
 * 
 * Format for class ProteinSequenceFormattedDisplay_Main_displayWidget:  mods per sequence position:  
 * 		 Map<integer, Object> Map < position 1 based (integer) : { Object: residue  (string), masses: [ mass (number) ] } >
 * 
 * Match format from loadedDataPerProjectSearchIdHolder.get_staticModificationsOnProtein_KeyProteinSequenceVersionId();
 * 
 * @returns  Map < {integer: position 1 based} : [ <mass> ] > -- Format for class ProteinSequenceFormattedDisplay_Main_displayWidget:
 */
const _get_staticModificationMasses_All_OnProteinByPosition = async function(
    {
        proteinSequenceVersionId, projectSearchIds, commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root
    }: {
        proteinSequenceVersionId: number
        projectSearchIds: Array<number>
        commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root: CommonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root
    }) : Promise<ProteinSequenceWidgetDisplay_Component_Data__Build__staticModificationMassesForProteinPositions_PARAM> {
    try {
        //  Format for class ProteinSequenceFormattedDisplay_Main_displayWidget:
        // Map<integer, Object> Map < position 1 based (integer) : { Object: residue  (string), massesArray: [ mass (number) ], massesSet: Set< mass (number)> >
        const modsOnProteinByPosition : ProteinSequenceWidgetDisplay_Component_Data__Build__staticModificationMassesForProteinPositions_PARAM = new Map();

        {
            for ( const projectSearchId of projectSearchIds ) {

                const commonData_LoadedFromServer_PerSearch_For_ProjectSearchId =
                    commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root.get__commonData_LoadedFromServer_PerSearch_For_ProjectSearchId(projectSearchId);

                const get_StaticModifications_OnProteinSequence_For_ProteinSequenceVersionId_Holder_ReturnPromise_Result =
                    await commonData_LoadedFromServer_PerSearch_For_ProjectSearchId.
                    get_commonData_LoadedFromServer_SingleSearch__StaticModifications_OnProteinSequence_For_ProteinSequenceVersionId().
                    get_StaticModifications_OnProteinSequence_For_ProteinSequenceVersionId_Holder__For_ProteinSequenceVersionId_ReturnPromise(proteinSequenceVersionId);

                const staticModifications_OnProteinSequence_For_ProteinSequenceVersionId_Holder =
                    get_StaticModifications_OnProteinSequence_For_ProteinSequenceVersionId_Holder_ReturnPromise_Result.staticModifications_OnProteinSequence_For_ProteinSequenceVersionId_Holder

                const staticModificationMassesForProteinPositions =
                    staticModifications_OnProteinSequence_For_ProteinSequenceVersionId_Holder.get_StaticModifications_ResiduesPositions_For_ProteinSequenceVersionId(proteinSequenceVersionId)

                for ( const mapEntry of staticModificationMassesForProteinPositions.entries() ) {
                    //  Currently a single array of all  mods for the protein.  Maybe make it a Map of mods at positions

                    //  modificationOnProtein { mass: 9945.99, position: 23, reportedPeptideId: 26043 }

                    const position = mapEntry[ 0 ];
                    const dataForPosition = mapEntry[ 1 ];

                    let resultDataForPosition: ProteinSequenceWidgetDisplay_Component_Data__Build__staticModificationMassesForProteinPositions_PARAM_Entry = modsOnProteinByPosition.get( position );

                    if ( ! resultDataForPosition ) {

                        resultDataForPosition = { residue : dataForPosition.residue, massesSet : new Set(), massesArray: undefined };
                        modsOnProteinByPosition.set( position, resultDataForPosition );
                    }

                    //  Copy all masses from entry for project search id to output Set
                    //     Round the mass since Multiple Search
                    for ( const mass of dataForPosition.massesSet ) {
                        const roundedMass = _roundModificationMass_ReturnNumber_LocalFunction({ mass });
                        resultDataForPosition.massesSet.add( roundedMass );
                    }
                }
            }

            //  Sort masses at each position
            for ( const modsOnProteinByPositionEntry of modsOnProteinByPosition.entries() ) {
                const position = modsOnProteinByPositionEntry[ 0 ];
                const dataForPosition = modsOnProteinByPositionEntry[ 1 ];
                const massesAtPositionArray = Array.from( dataForPosition.massesSet );
                limelight__Sort_ArrayOfNumbers_SortArrayInPlace(massesAtPositionArray);
                //  Place the sorted Array in the final output Map
                dataForPosition.massesArray = massesAtPositionArray;
            }
        }

        return modsOnProteinByPosition;

    } catch (e) { reportWebErrorToServer.reportErrorObjectToServer({errorException: e}); throw e }
}

////////////////////////////////////////////
	
//   Modification Mass Rounding to provide some level of commonality between searches

/**
 * 
 */
const _roundModificationMass_ReturnNumber_LocalFunction = function({ mass }: { mass: number }) {
	return modificationMass_CommonRounding_ReturnNumber( mass );  // Call external function
}

	

///////////////////////////////////////////////


class ProteinPage_Display__SingleProtein_MainContent_Component_nonClass_Functions {
    static initialPopulate = initialPopulate
    static compute_searchSubGroup_Ids_Selected = compute_searchSubGroup_Ids_Selected
    static compute_searchSubGroup_Are_All_SearchSubGroupIds_Selected = compute_searchSubGroup_Are_All_SearchSubGroupIds_Selected
    static compute_searchSubGroup_PropValue = compute_searchSubGroup_PropValue
    static compute_searchDetailsAndFilterBlock_MainPage_Root_Props_PropValue = compute_searchDetailsAndFilterBlock_MainPage_Root_Props_PropValue
    static create_ModificationMass_UserSelections_ComponentData = create_ModificationMass_UserSelections_ComponentData
    static create_ReporterIons_UserSelections_ComponentData = create_ReporterIons_UserSelections_ComponentData
    static create_PeptideSequence_UserSelections_ComponentData = create_PeptideSequence_UserSelections_ComponentData
    static create_ProteinSequenceWidgetDisplay_Component_Data =  create_ProteinSequenceWidgetDisplay_Component_Data
}

export {
    ProteinPage_Display__SingleProtein_MainContent_Component_nonClass_Functions,
    ProteinPage_Display__SingleProtein_MainContent_Component_nonClass_Functions__LinksToExternalResources_Class // return type
}
